import { __assign } from "tslib";
export var AssociateKmsKeyRequest;
(function (AssociateKmsKeyRequest) {
    AssociateKmsKeyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AssociateKmsKeyRequest || (AssociateKmsKeyRequest = {}));
export var InvalidParameterException;
(function (InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InvalidParameterException || (InvalidParameterException = {}));
export var OperationAbortedException;
(function (OperationAbortedException) {
    OperationAbortedException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OperationAbortedException || (OperationAbortedException = {}));
export var ResourceNotFoundException;
(function (ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
export var ServiceUnavailableException;
(function (ServiceUnavailableException) {
    ServiceUnavailableException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
export var CancelExportTaskRequest;
(function (CancelExportTaskRequest) {
    CancelExportTaskRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CancelExportTaskRequest || (CancelExportTaskRequest = {}));
export var InvalidOperationException;
(function (InvalidOperationException) {
    InvalidOperationException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InvalidOperationException || (InvalidOperationException = {}));
export var CreateExportTaskRequest;
(function (CreateExportTaskRequest) {
    CreateExportTaskRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateExportTaskRequest || (CreateExportTaskRequest = {}));
export var CreateExportTaskResponse;
(function (CreateExportTaskResponse) {
    CreateExportTaskResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateExportTaskResponse || (CreateExportTaskResponse = {}));
export var LimitExceededException;
(function (LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LimitExceededException || (LimitExceededException = {}));
export var ResourceAlreadyExistsException;
(function (ResourceAlreadyExistsException) {
    ResourceAlreadyExistsException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResourceAlreadyExistsException || (ResourceAlreadyExistsException = {}));
export var CreateLogGroupRequest;
(function (CreateLogGroupRequest) {
    CreateLogGroupRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateLogGroupRequest || (CreateLogGroupRequest = {}));
export var CreateLogStreamRequest;
(function (CreateLogStreamRequest) {
    CreateLogStreamRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateLogStreamRequest || (CreateLogStreamRequest = {}));
export var DataAlreadyAcceptedException;
(function (DataAlreadyAcceptedException) {
    DataAlreadyAcceptedException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DataAlreadyAcceptedException || (DataAlreadyAcceptedException = {}));
export var DeleteDestinationRequest;
(function (DeleteDestinationRequest) {
    DeleteDestinationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteDestinationRequest || (DeleteDestinationRequest = {}));
export var DeleteLogGroupRequest;
(function (DeleteLogGroupRequest) {
    DeleteLogGroupRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteLogGroupRequest || (DeleteLogGroupRequest = {}));
export var DeleteLogStreamRequest;
(function (DeleteLogStreamRequest) {
    DeleteLogStreamRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteLogStreamRequest || (DeleteLogStreamRequest = {}));
export var DeleteMetricFilterRequest;
(function (DeleteMetricFilterRequest) {
    DeleteMetricFilterRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteMetricFilterRequest || (DeleteMetricFilterRequest = {}));
export var DeleteQueryDefinitionRequest;
(function (DeleteQueryDefinitionRequest) {
    DeleteQueryDefinitionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteQueryDefinitionRequest || (DeleteQueryDefinitionRequest = {}));
export var DeleteQueryDefinitionResponse;
(function (DeleteQueryDefinitionResponse) {
    DeleteQueryDefinitionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteQueryDefinitionResponse || (DeleteQueryDefinitionResponse = {}));
export var DeleteResourcePolicyRequest;
(function (DeleteResourcePolicyRequest) {
    DeleteResourcePolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteResourcePolicyRequest || (DeleteResourcePolicyRequest = {}));
export var DeleteRetentionPolicyRequest;
(function (DeleteRetentionPolicyRequest) {
    DeleteRetentionPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteRetentionPolicyRequest || (DeleteRetentionPolicyRequest = {}));
export var DeleteSubscriptionFilterRequest;
(function (DeleteSubscriptionFilterRequest) {
    DeleteSubscriptionFilterRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteSubscriptionFilterRequest || (DeleteSubscriptionFilterRequest = {}));
export var DescribeDestinationsRequest;
(function (DescribeDestinationsRequest) {
    DescribeDestinationsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeDestinationsRequest || (DescribeDestinationsRequest = {}));
export var Destination;
(function (Destination) {
    Destination.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Destination || (Destination = {}));
export var DescribeDestinationsResponse;
(function (DescribeDestinationsResponse) {
    DescribeDestinationsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeDestinationsResponse || (DescribeDestinationsResponse = {}));
export var ExportTaskStatusCode;
(function (ExportTaskStatusCode) {
    ExportTaskStatusCode["CANCELLED"] = "CANCELLED";
    ExportTaskStatusCode["COMPLETED"] = "COMPLETED";
    ExportTaskStatusCode["FAILED"] = "FAILED";
    ExportTaskStatusCode["PENDING"] = "PENDING";
    ExportTaskStatusCode["PENDING_CANCEL"] = "PENDING_CANCEL";
    ExportTaskStatusCode["RUNNING"] = "RUNNING";
})(ExportTaskStatusCode || (ExportTaskStatusCode = {}));
export var DescribeExportTasksRequest;
(function (DescribeExportTasksRequest) {
    DescribeExportTasksRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeExportTasksRequest || (DescribeExportTasksRequest = {}));
export var ExportTaskExecutionInfo;
(function (ExportTaskExecutionInfo) {
    ExportTaskExecutionInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ExportTaskExecutionInfo || (ExportTaskExecutionInfo = {}));
export var ExportTaskStatus;
(function (ExportTaskStatus) {
    ExportTaskStatus.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ExportTaskStatus || (ExportTaskStatus = {}));
export var ExportTask;
(function (ExportTask) {
    ExportTask.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ExportTask || (ExportTask = {}));
export var DescribeExportTasksResponse;
(function (DescribeExportTasksResponse) {
    DescribeExportTasksResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeExportTasksResponse || (DescribeExportTasksResponse = {}));
export var DescribeLogGroupsRequest;
(function (DescribeLogGroupsRequest) {
    DescribeLogGroupsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLogGroupsRequest || (DescribeLogGroupsRequest = {}));
export var LogGroup;
(function (LogGroup) {
    LogGroup.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LogGroup || (LogGroup = {}));
export var DescribeLogGroupsResponse;
(function (DescribeLogGroupsResponse) {
    DescribeLogGroupsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLogGroupsResponse || (DescribeLogGroupsResponse = {}));
export var OrderBy;
(function (OrderBy) {
    OrderBy["LastEventTime"] = "LastEventTime";
    OrderBy["LogStreamName"] = "LogStreamName";
})(OrderBy || (OrderBy = {}));
export var DescribeLogStreamsRequest;
(function (DescribeLogStreamsRequest) {
    DescribeLogStreamsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLogStreamsRequest || (DescribeLogStreamsRequest = {}));
export var LogStream;
(function (LogStream) {
    LogStream.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LogStream || (LogStream = {}));
export var DescribeLogStreamsResponse;
(function (DescribeLogStreamsResponse) {
    DescribeLogStreamsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeLogStreamsResponse || (DescribeLogStreamsResponse = {}));
export var DescribeMetricFiltersRequest;
(function (DescribeMetricFiltersRequest) {
    DescribeMetricFiltersRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeMetricFiltersRequest || (DescribeMetricFiltersRequest = {}));
export var MetricTransformation;
(function (MetricTransformation) {
    MetricTransformation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MetricTransformation || (MetricTransformation = {}));
export var MetricFilter;
(function (MetricFilter) {
    MetricFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MetricFilter || (MetricFilter = {}));
export var DescribeMetricFiltersResponse;
(function (DescribeMetricFiltersResponse) {
    DescribeMetricFiltersResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeMetricFiltersResponse || (DescribeMetricFiltersResponse = {}));
export var QueryStatus;
(function (QueryStatus) {
    QueryStatus["Cancelled"] = "Cancelled";
    QueryStatus["Complete"] = "Complete";
    QueryStatus["Failed"] = "Failed";
    QueryStatus["Running"] = "Running";
    QueryStatus["Scheduled"] = "Scheduled";
})(QueryStatus || (QueryStatus = {}));
export var DescribeQueriesRequest;
(function (DescribeQueriesRequest) {
    DescribeQueriesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeQueriesRequest || (DescribeQueriesRequest = {}));
export var QueryInfo;
(function (QueryInfo) {
    QueryInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(QueryInfo || (QueryInfo = {}));
export var DescribeQueriesResponse;
(function (DescribeQueriesResponse) {
    DescribeQueriesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeQueriesResponse || (DescribeQueriesResponse = {}));
export var DescribeQueryDefinitionsRequest;
(function (DescribeQueryDefinitionsRequest) {
    DescribeQueryDefinitionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeQueryDefinitionsRequest || (DescribeQueryDefinitionsRequest = {}));
export var QueryDefinition;
(function (QueryDefinition) {
    QueryDefinition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(QueryDefinition || (QueryDefinition = {}));
export var DescribeQueryDefinitionsResponse;
(function (DescribeQueryDefinitionsResponse) {
    DescribeQueryDefinitionsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeQueryDefinitionsResponse || (DescribeQueryDefinitionsResponse = {}));
export var DescribeResourcePoliciesRequest;
(function (DescribeResourcePoliciesRequest) {
    DescribeResourcePoliciesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeResourcePoliciesRequest || (DescribeResourcePoliciesRequest = {}));
export var ResourcePolicy;
(function (ResourcePolicy) {
    ResourcePolicy.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResourcePolicy || (ResourcePolicy = {}));
export var DescribeResourcePoliciesResponse;
(function (DescribeResourcePoliciesResponse) {
    DescribeResourcePoliciesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeResourcePoliciesResponse || (DescribeResourcePoliciesResponse = {}));
export var DescribeSubscriptionFiltersRequest;
(function (DescribeSubscriptionFiltersRequest) {
    DescribeSubscriptionFiltersRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSubscriptionFiltersRequest || (DescribeSubscriptionFiltersRequest = {}));
export var Distribution;
(function (Distribution) {
    Distribution["ByLogStream"] = "ByLogStream";
    Distribution["Random"] = "Random";
})(Distribution || (Distribution = {}));
export var SubscriptionFilter;
(function (SubscriptionFilter) {
    SubscriptionFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SubscriptionFilter || (SubscriptionFilter = {}));
export var DescribeSubscriptionFiltersResponse;
(function (DescribeSubscriptionFiltersResponse) {
    DescribeSubscriptionFiltersResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeSubscriptionFiltersResponse || (DescribeSubscriptionFiltersResponse = {}));
export var DisassociateKmsKeyRequest;
(function (DisassociateKmsKeyRequest) {
    DisassociateKmsKeyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DisassociateKmsKeyRequest || (DisassociateKmsKeyRequest = {}));
export var FilteredLogEvent;
(function (FilteredLogEvent) {
    FilteredLogEvent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FilteredLogEvent || (FilteredLogEvent = {}));
export var FilterLogEventsRequest;
(function (FilterLogEventsRequest) {
    FilterLogEventsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FilterLogEventsRequest || (FilterLogEventsRequest = {}));
export var SearchedLogStream;
(function (SearchedLogStream) {
    SearchedLogStream.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SearchedLogStream || (SearchedLogStream = {}));
export var FilterLogEventsResponse;
(function (FilterLogEventsResponse) {
    FilterLogEventsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FilterLogEventsResponse || (FilterLogEventsResponse = {}));
export var GetLogEventsRequest;
(function (GetLogEventsRequest) {
    GetLogEventsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetLogEventsRequest || (GetLogEventsRequest = {}));
export var OutputLogEvent;
(function (OutputLogEvent) {
    OutputLogEvent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OutputLogEvent || (OutputLogEvent = {}));
export var GetLogEventsResponse;
(function (GetLogEventsResponse) {
    GetLogEventsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetLogEventsResponse || (GetLogEventsResponse = {}));
export var GetLogGroupFieldsRequest;
(function (GetLogGroupFieldsRequest) {
    GetLogGroupFieldsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetLogGroupFieldsRequest || (GetLogGroupFieldsRequest = {}));
export var LogGroupField;
(function (LogGroupField) {
    LogGroupField.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LogGroupField || (LogGroupField = {}));
export var GetLogGroupFieldsResponse;
(function (GetLogGroupFieldsResponse) {
    GetLogGroupFieldsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetLogGroupFieldsResponse || (GetLogGroupFieldsResponse = {}));
export var GetLogRecordRequest;
(function (GetLogRecordRequest) {
    GetLogRecordRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetLogRecordRequest || (GetLogRecordRequest = {}));
export var GetLogRecordResponse;
(function (GetLogRecordResponse) {
    GetLogRecordResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetLogRecordResponse || (GetLogRecordResponse = {}));
export var GetQueryResultsRequest;
(function (GetQueryResultsRequest) {
    GetQueryResultsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetQueryResultsRequest || (GetQueryResultsRequest = {}));
export var ResultField;
(function (ResultField) {
    ResultField.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResultField || (ResultField = {}));
export var QueryStatistics;
(function (QueryStatistics) {
    QueryStatistics.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(QueryStatistics || (QueryStatistics = {}));
export var GetQueryResultsResponse;
(function (GetQueryResultsResponse) {
    GetQueryResultsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetQueryResultsResponse || (GetQueryResultsResponse = {}));
export var InputLogEvent;
(function (InputLogEvent) {
    InputLogEvent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InputLogEvent || (InputLogEvent = {}));
export var InvalidSequenceTokenException;
(function (InvalidSequenceTokenException) {
    InvalidSequenceTokenException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InvalidSequenceTokenException || (InvalidSequenceTokenException = {}));
export var ListTagsLogGroupRequest;
(function (ListTagsLogGroupRequest) {
    ListTagsLogGroupRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListTagsLogGroupRequest || (ListTagsLogGroupRequest = {}));
export var ListTagsLogGroupResponse;
(function (ListTagsLogGroupResponse) {
    ListTagsLogGroupResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListTagsLogGroupResponse || (ListTagsLogGroupResponse = {}));
export var PutDestinationRequest;
(function (PutDestinationRequest) {
    PutDestinationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutDestinationRequest || (PutDestinationRequest = {}));
export var PutDestinationResponse;
(function (PutDestinationResponse) {
    PutDestinationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutDestinationResponse || (PutDestinationResponse = {}));
export var PutDestinationPolicyRequest;
(function (PutDestinationPolicyRequest) {
    PutDestinationPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutDestinationPolicyRequest || (PutDestinationPolicyRequest = {}));
export var PutLogEventsRequest;
(function (PutLogEventsRequest) {
    PutLogEventsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutLogEventsRequest || (PutLogEventsRequest = {}));
export var RejectedLogEventsInfo;
(function (RejectedLogEventsInfo) {
    RejectedLogEventsInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RejectedLogEventsInfo || (RejectedLogEventsInfo = {}));
export var PutLogEventsResponse;
(function (PutLogEventsResponse) {
    PutLogEventsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutLogEventsResponse || (PutLogEventsResponse = {}));
export var UnrecognizedClientException;
(function (UnrecognizedClientException) {
    UnrecognizedClientException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UnrecognizedClientException || (UnrecognizedClientException = {}));
export var PutMetricFilterRequest;
(function (PutMetricFilterRequest) {
    PutMetricFilterRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutMetricFilterRequest || (PutMetricFilterRequest = {}));
export var PutQueryDefinitionRequest;
(function (PutQueryDefinitionRequest) {
    PutQueryDefinitionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutQueryDefinitionRequest || (PutQueryDefinitionRequest = {}));
export var PutQueryDefinitionResponse;
(function (PutQueryDefinitionResponse) {
    PutQueryDefinitionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutQueryDefinitionResponse || (PutQueryDefinitionResponse = {}));
export var PutResourcePolicyRequest;
(function (PutResourcePolicyRequest) {
    PutResourcePolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutResourcePolicyRequest || (PutResourcePolicyRequest = {}));
export var PutResourcePolicyResponse;
(function (PutResourcePolicyResponse) {
    PutResourcePolicyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutResourcePolicyResponse || (PutResourcePolicyResponse = {}));
export var PutRetentionPolicyRequest;
(function (PutRetentionPolicyRequest) {
    PutRetentionPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutRetentionPolicyRequest || (PutRetentionPolicyRequest = {}));
export var PutSubscriptionFilterRequest;
(function (PutSubscriptionFilterRequest) {
    PutSubscriptionFilterRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PutSubscriptionFilterRequest || (PutSubscriptionFilterRequest = {}));
export var QueryCompileErrorLocation;
(function (QueryCompileErrorLocation) {
    QueryCompileErrorLocation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(QueryCompileErrorLocation || (QueryCompileErrorLocation = {}));
export var QueryCompileError;
(function (QueryCompileError) {
    QueryCompileError.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(QueryCompileError || (QueryCompileError = {}));
export var MalformedQueryException;
(function (MalformedQueryException) {
    MalformedQueryException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MalformedQueryException || (MalformedQueryException = {}));
export var StartQueryRequest;
(function (StartQueryRequest) {
    StartQueryRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartQueryRequest || (StartQueryRequest = {}));
export var StartQueryResponse;
(function (StartQueryResponse) {
    StartQueryResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartQueryResponse || (StartQueryResponse = {}));
export var StopQueryRequest;
(function (StopQueryRequest) {
    StopQueryRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StopQueryRequest || (StopQueryRequest = {}));
export var StopQueryResponse;
(function (StopQueryResponse) {
    StopQueryResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StopQueryResponse || (StopQueryResponse = {}));
export var TagLogGroupRequest;
(function (TagLogGroupRequest) {
    TagLogGroupRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TagLogGroupRequest || (TagLogGroupRequest = {}));
export var TestMetricFilterRequest;
(function (TestMetricFilterRequest) {
    TestMetricFilterRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TestMetricFilterRequest || (TestMetricFilterRequest = {}));
export var MetricFilterMatchRecord;
(function (MetricFilterMatchRecord) {
    MetricFilterMatchRecord.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MetricFilterMatchRecord || (MetricFilterMatchRecord = {}));
export var TestMetricFilterResponse;
(function (TestMetricFilterResponse) {
    TestMetricFilterResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TestMetricFilterResponse || (TestMetricFilterResponse = {}));
export var UntagLogGroupRequest;
(function (UntagLogGroupRequest) {
    UntagLogGroupRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UntagLogGroupRequest || (UntagLogGroupRequest = {}));
//# sourceMappingURL=models_0.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@aws-sdk/client-cloudwatch-logs/dist/es/models/models_0.js
// module id = 33
// module chunks = 0